// src/components/JobForm.js
import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Container } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useLocation, useNavigate } from 'react-router-dom';
import { createJob, getJobById, updateJob } from '../../../../services/JobService';


const JobForm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [job, setJob] = useState({
        jobTitle: '',
        slug: '',
        ppe: '',
        status: 'active',
        hazards: [{ hazard: '', description: '', controls: '' }],
    });
    useEffect(() => {
        const apiCall = async () => {
            try {
                if(location.state != null){
                    const job = await getJobById(location.state.id);
                    setJob({
                        _id: job._id,
                        jobTitle: job.jobTitle,
                        slug: job.slug,
                        ppe: job.ppe,
                        status: job.status,
                        hazards: job.hazards.map((element)=>{
                            return { _id:element.hazard._id, hazard: element.hazard, description: element.description, controls: element.controls }
                        })
                    });
                }
            } catch (error) {
                console.error(`Error fetching job with id`, error);
            }
        }
        apiCall()
    }, [])

  

    // if (currentJob != null && JSON.stringify(currentJob) !== JSON.stringify(job)) {
    //     setJob(currentJob);
    // }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setJob({ ...job, [name]: value });
    };

    const handleHazardChange = (index, name, value) => {
        const newHazards = job.hazards.map((hazard, i) =>
            i === index ? { ...hazard, [name]: value } : hazard
        );
        setJob({ ...job, hazards: newHazards });
    };

    const handleAddHazard = () => {
        setJob({
            ...job,
            hazards: [...job.hazards, { hazard: '', description: '', controls: '' }],
        });
    };

    const handleRemoveHazard = (index) => {
        if (index > 0) {
            setJob({
                ...job,
                hazards: job.hazards.filter((_, i) => i !== index),
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (job._id) {
                const updatedJob = await updateJob(job._id, job);
            } else {
                const newJob = await createJob(job);
            }
        } catch (error) {
            console.error('Error saving job', error);
        }
        setJob({
            jobTitle: '',
            slug: '',
            ppe: '',
            status: '',
            hazards: [{ hazard: '', description: '', controls: '' }],
        });
       // navigate('/settings')
        
    };

    const handleCancel = ()=>{
        navigate('/settings')
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <Form.Group controlId="formJobTitle">
                        <Form.Label>Job Title</Form.Label>
                        <Form.Control
                            type="text"
                            name="jobTitle"
                            value={job.jobTitle}
                            onChange={handleChange}
                            placeholder="Job Title"
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group controlId="formSlug">
                        <Form.Label>Slug</Form.Label>
                        <Form.Control
                            type="text"
                            name="slug"
                            value={job.slug}
                            onChange={handleChange}
                            placeholder="Slug"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group controlId="formSlug">
                        <Form.Label>PPE</Form.Label>
                        <Form.Control
                            type="text"
                            name="ppe"
                            value={job.ppe}
                            onChange={handleChange}
                            placeholder="PPE"
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group controlId="formStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Control
                            as="select"
                            name="status"
                            value={job.status}
                            onChange={handleChange}
                        >
                            <option value="active">ACTIVE</option>
                            <option value="deleted">DELETED</option>
                        </Form.Control>
                    </Form.Group>
                </Col>
            </Row>

            <hr />
            <h3>Hazards</h3>
            {job.hazards.map((hazard, index) => (
                <div key={index} className="mb-4">
                    <Form.Group controlId={`formHazard${index}`}>
                        <Form.Label>Hazard</Form.Label>
                        <Form.Control
                            type="text"
                            name="hazard"
                            value={hazard.hazard}
                            onChange={(e) => handleHazardChange(index, 'hazard', e.target.value)}
                            placeholder="Hazard"
                        />
                    </Form.Group>
                    <Form.Group controlId={`formDescription${index}`}>
                        <Form.Label>Description</Form.Label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={hazard.description}
                            onChange={(event, editor) => handleHazardChange(index, 'description', editor.getData())}
                            onReady={(editor) => {
                                // Set initial data
                                editor.setData(hazard.description);
                            }}
                        />
                    </Form.Group>
                    <Form.Group controlId={`formControls${index}`}>
                        <Form.Label>Controls</Form.Label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={hazard.controls}
                            onChange={(event, editor) => handleHazardChange(index, 'controls', editor.getData())}
                            onReady={(editor) => {
                                // Set initial data
                                editor.setData(hazard.controls);
                            }}
                        />
                    </Form.Group>
                    {index > 0 ?
                        <Button className='mt-5' variant="danger" onClick={() => handleRemoveHazard(index)}>
                            Remove Hazard
                        </Button> :
                        ""
                    }

                </div>
            ))}
            <div className="d-flex justify-content-end">
                <Button variant="secondary" type='button' style={{marginRight: "5px"}} onClick={handleAddHazard} className="mr-3">
                    Add Hazard
                </Button>
                <Button type="button" style={{marginRight: "5px"}}  onClick={handleCancel} className="mr-3">
                    Cancel
                </Button>
                <Button type="submit" variant="success">
                    Save
                </Button>
            </div>
        </Form>
    );
};

export default JobForm;
